import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import { movies, tvshows } from "@/lib/content";

type TabKey = "movie" | "tvshow";

const TABS: { key: TabKey; label: string; to: string }[] = [
  { key: "movie", label: "最新电影", to: "/movies" },
  { key: "tvshow", label: "最新电视剧", to: "/tvshows" },
];

export default function LatestSection() {
  const [tab, setTab] = useState<TabKey>("movie");

  const items = useMemo(() => {
    if (tab === "movie") {
      return [...movies].sort((a, b) => b.year - a.year || b.rating - a.rating).slice(0, 8);
    }
    return [...tvshows].sort((a, b) => b.year - a.year || b.rating - a.rating).slice(0, 8);
  }, [tab]);

  const activeTab = TABS.find((item) => item.key === tab);

  return (
    <section className="w-full border-t border-background-200/70 bg-background-100/40 px-4 py-12 md:px-6 lg:px-10 lg:py-16">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-label uppercase tracking-widest text-primary-400">
            <span className="h-1 w-6 rounded-full bg-primary-500" />
            最新上线
          </span>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新影视推荐</h2>
        </div>

        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 rounded-full border border-background-200/70 bg-background-50/70 p-1">
            {TABS.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-label transition-colors duration-200 ${
                  tab === item.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          {activeTab && (
            <Link
              to={activeTab.to}
              className="hidden items-center gap-1 whitespace-nowrap text-sm font-label text-foreground-600 transition-colors duration-200 hover:text-primary-400 sm:flex"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {items.map((item) => (
          <MediaCard
            key={item.id}
            id={item.id}
            title={item.title}
            year={item.year}
            cover={item.cover}
            summary={item.summary}
            tags={[item.region, ...item.genres]}
            rating={item.rating}
          />
        ))}
      </div>
    </section>
  );
}